import { AcaoTagsVendaEnum } from '@shared/enums/vendas/acao-tags-venda.enum';

// Tags em lote nos documentos selecionados (espelho de AlterarTagsVendaRequest do OrquestradorVendas,
// POST ProcessoVenda/tags). Em "substituir" a lista pode ir vazia: tira todas as tags. `acao` trafega como
// número (AcaoTagsVendaEnum: 1 incluir, 2 remover, 3 substituir), como nos demais contratos HTTP.
export class AlterarTagsVendaRequest {
    public idsVenda: number[] = [];
    public idsTagVenda: number[] = [];
    public acao: number = AcaoTagsVendaEnum.Incluir;
}
